<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between">
              <h6>標籤管理</h6>
              <soft-button
                color="success"
                size="sm"
                @click="openModal()"
                v-if="can('product.create')"
              >
                <i class="fas fa-plus me-1"></i> 新增標籤
              </soft-button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      名稱
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Slug
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      類型
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tag in tags" :key="tag.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-col justify-content-center">
                          <h6 class="mb-0 text-sm">{{ tag.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ tag.slug }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        formatType(tag.type)
                      }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <soft-badge
                        :color="tag.is_active ? 'success' : 'secondary'"
                        size="sm"
                      >
                        {{ tag.is_active ? "啟用" : "停用" }}
                      </soft-badge>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        @click="openModal(tag)"
                        v-if="can('product.edit')"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deleteTag(tag.id)"
                        v-if="can('product.delete')"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="showModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? "編輯標籤" : "新增標籤" }}</h5>
            <button
              type="button"
              class="btn-close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveTag">
              <div class="mb-3">
                <label class="form-label">名稱</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.name"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Slug</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.slug"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">類型</label>
                <select class="form-control" v-model="form.type" required>
                  <option value="category_tag">分類標籤</option>
                  <option value="brand_tag">品牌標籤</option>
                  <option value="spec_tag">規格標籤</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isActive"
                  v-model="form.is_active"
                />
                <label class="form-check-label" for="isActive">啟用</label>
              </div>
              <div class="text-end mt-3">
                <button
                  type="button"
                  class="btn btn-secondary me-2"
                  @click="closeModal"
                >
                  取消
                </button>
                <button type="submit" class="btn btn-success">儲存</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import request from "@/utils/request";
import Swal from "sweetalert2";
import { hasPermission } from "@/utils/permissions";

export default {
  name: "Tags",
  components: {
    SoftButton,
    SoftBadge,
  },
  data() {
    return {
      tags: [],
      showModal: false,
      form: {
        id: null,
        name: "",
        slug: "",
        type: "other",
        is_active: true,
      },
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  created() {
    this.fetchTags();
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchTags() {
      try {
        const response = await request.get("/api/admin/tags");
        this.tags = response.data.data;
      } catch (error) {
        console.error("Failed to fetch tags", error);
      }
    },
    formatType(type) {
      const map = {
        category_tag: "分類標籤",
        brand_tag: "品牌標籤",
        spec_tag: "規格標籤",
        other: "其他",
      };
      return map[type] || type;
    },
    openModal(tag = null) {
      if (tag) {
        this.form = { ...tag, is_active: !!tag.is_active };
      } else {
        this.form = {
          id: null,
          name: "",
          slug: "",
          type: "other",
          is_active: true,
        };
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async saveTag() {
      try {
        if (this.form.id) {
          await request.put(`/api/admin/tags/${this.form.id}`, this.form);
        } else {
          await request.post("/api/admin/tags", this.form);
        }
        this.closeModal();
        this.fetchTags();
        Swal.fire("成功", "儲存成功", "success");
      } catch (error) {
        console.error("Failed to save tag", error);
        Swal.fire("錯誤", "儲存失敗", "error");
      }
    },
    async deleteTag(id) {
      Swal.fire({
        title: "確定要刪除此標籤嗎？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea0606",
        confirmButtonText: "確定刪除",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.delete(`/api/admin/tags/${id}`);
            this.fetchTags();
            Swal.fire("已刪除", "刪除成功", "success");
          } catch (error) {
            console.error("Failed to delete tag", error);
            Swal.fire("錯誤", "刪除失敗", "error");
          }
        }
      });
    },
  },
};
</script>
